
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'sidebar-footer',
  components: {}
})
